<template>
  <ValidationObserver v-slot="{ passes }">
    <form @submit.prevent="passes(onSubmit)">
      <div class="container text-left">
        <AsnFieldset />

        <ExchangeFieldset />

        <div v-if="!formData.noExchanges">
          <ExchangeCheckbox
            v-for="item in formData.exchangeOptions"
            :key="item"
            :name="item"
          />
        </div>

        <ContactFieldset />

        <div class="form-row footer">
          <div class="footer-text col-xs-12 col-sm-12 col-md-12">
            <span
              v-if="captchaError"
              class="error"
            >The captcha validation failed, please try again.</span>
            <span
              v-if="submitError"
              class="error"
            >Something went wrong while sending your request, please try again.</span>
            <button
              type="submit"
              class="anx-button"
            >
              Submit >
            </button>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>


<script>
import AsnFieldset from "@/components/AsnFieldset.vue";
import ExchangeFieldset from "@/components/ExchangeFieldset.vue";
import ContactFieldset from "@/components/ContactFieldset.vue";
import ExchangeCheckbox from "@/components/ExchangeCheckbox.vue";
import {initCaptcha, getCaptchaSolution, resetCaptcha} from "./script/captcha";
import 'whatwg-fetch';

export default {
  name: "Peering",
  components: {
    ExchangeCheckbox,
    AsnFieldset,
    ExchangeFieldset,
    ContactFieldset
  },
  data() {
    return {
      captchaError: false,
      submitError: false
    };
  },
  computed: {
    formData() {
      return this.$store.state.formData;
    },
    networkDetails() {
      return this.$store.state.networkDetails;
    }
  },
  mounted() {
    initCaptcha();
  },
  methods: {
    async onSubmit() {
      this.captchaError = false;
      this.submitError = false;

      let error = 0;
      if (this.formData.choosedExchanges.length > 0) {
        for (let i = 0; i < this.formData.choosedExchanges.length; i++) {
          this.formData.choosedExchanges[i].error = "";
          if (this.formData.choosedExchanges[i].ip4.length <= 0) {
            this.formData.choosedExchanges[i].error =
              "The field IPv4 is required!";
            error = 1;
          }
        }

        if (error === 0) {
          const captchaOk = await this.ensureCaptcha();
          if (!captchaOk) {
            this.captchaError = true;
            return;
          }

          const sendOk = await this.$store.dispatch("fetchData");
          if (!sendOk) {
            this.submitError = true;
            return;
          }

          this.$store.commit("resetAll");
          this.$router.push("/success");
        }
      }
    },

    async ensureCaptcha() {
      const token = await getCaptchaSolution();
      if (!token) {
        await resetCaptcha();
        return false;
      }

      try {
        const res = await fetch("/api/recaptcha/request", {
          method: "POST",
          body: JSON.stringify(token),
          headers: { "Content-Type": "application/json" }
        });

        if (res.status === 200) {
          const success = (await res.json()).success === true;
          if (!success) {
            await resetCaptcha();
          }
          return success;
        }
      } catch (_e) {
        await resetCaptcha();
        return false;
      }

      await resetCaptcha();
      return false;
    }
  }
};
</script>

<style lang="scss">
@import "./less/anx-button.scss";
@import "./less/anx-checkbox.scss";
@import "./less/anx-peering-form.scss";
</style>
